// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1k2B2","right":"Footer_right__1gIQg","buttons":"Footer_buttons__2IwzH"};